import {useAccountStore} from '../store/account'

function generateContextId() {
	let contextIdTemplate = 'xxxxyxxxyxxxyxxxyxxxyxxxyxxxyxxx'
	return contextIdTemplate.replace(/[xy]/g, function (c) {
		let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
		return v.toString(16)
	})
}

export default defineNuxtPlugin((nuxtApp) => {
	// Set the context id synchronously in the plugin body, where the request's
	// Nuxt/Pinia context is guaranteed valid. The previous version deferred this
	// into an `app:created` hook that called useAccountStore() — under concurrent
	// SSR that callback loses the request instance and throws "[nuxt] instance
	// unavailable", leaving contextId empty. A request with no X-TRIPENING-CONTEXT-ID
	// header is rejected 400 by the API, which blanks the hotel name + images.
	// Pass nuxtApp.$pinia explicitly so we never rely on active-instance resolution.
	const accountStore = useAccountStore(nuxtApp.$pinia as any)
	if (!accountStore.contextId) {
		accountStore.setContextId(generateContextId())
	}
})
